export default [
    {
      path: '/lease',
      name: 'lease',
      meta: {
        login: true
      }
    },
    { path: '/lease/VesselPSCConfigControl', name: 'VesselPSCConfigControl', component: resolve => require(['@/views/lease/VesselPSCConfigControl'], resolve)}
  ]


// WEBPACK FOOTER //
// ./src/config/router/lease.js